module.exports = __webpack_public_path__ + "static/media/Vector.6324aaa3.svg";